<template>
<b-container fluid class="top-padding bottom-padding no-horiz-padding">
    <div>
        <h2>Draft Contribution</h2>
        <p>Provide your original drafts to Handweaving.net for others to enjoy!</p>
    </div>

    <div v-if='!this.isAuthenticated'>
        <login-control prompt="Sign In Now" :show-as-link="false"/>Please sign in to contribute drafts.
    </div>

    <div v-if='this.isAuthenticated'>
        <div v-if='!draftImageUrl'>
            <form name="fileSelectionForm">
                <label class='btn btn-primary' for="fileUpload">Choose a WIF to Upload</label>
                <input style='opacity:0' id='fileUpload' type="file" ref='kFileUpload' name="fileUpload" accept='.wif' @change="uploadFile"/>
            </form>
        </div>

        <div class='top-padding' v-show='draftImageUrl'>
            <img :src='draftImageUrl' />
        </div>

        <b-form class='top-padding' v-if='draftImageUrl' :novalidate='true' @submit="onSubmit">
            <div>
                <h3>Do you want to save this draft to make it available on Handweaving.net?</h3>
            </div>

            <b-form-group id="titleInputGroup" :class="{ 'is-invalid': formSubmitAttempted && !isValidTitle() }">
                <b-form-text id="titleInputHelp">Draft title</b-form-text>
                <b-form-input id="titleInput" v-model="form.title" required placeholder="Enter draft title" :class="{ 'is-invalid': formSubmitAttempted && !isValidTitle() }">
                </b-form-input>
                <b-form-invalid-feedback id="titleInputFeedback">
                    Enter a title for this draft:
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="areaOfOriginInputGroup">
                <b-form-text id="areaOfOriginInputHelp">Area of origin</b-form-text>
                <b-form-input id="areaOfOriginInput" v-model="form.areaOfOrigin" required placeholder="Enter draft area of origin (optional)">
                </b-form-input>
                <b-form-invalid-feedback id="areaOfOriginInputFeedback">
                    Enter area of origin for this draft (optional):
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id='submitGroup'>
                <b-button id='saveSubmit' type='submit' name='saveSubmit' variant='primary'>Save Draft</b-button>
                <b-button variant='primary' @click='discardTemporaryDraft'>Discard Draft</b-button>
            </b-form-group>
        </b-form>

        <div class='top-padding'>
            <h3>Draft Contribution Policy</h3>
            <ul>
                <li class='small-bottom-padding'>We gladly accept drafts that are uploaded to the site by their original authors. By uploading a draft, you are giving us permission to provide it on Handweaving.net free of charge, with no royalties, payments, or other encumbrances.</li>
                <li class='small-bottom-padding'>All rights to and ownership of the draft remain yours including copyright, and you may later publish or use the draft elsewhere.</li>
                <li class='small-bottom-padding'>We will not distribute your contributed drafts in any other way, such as on CD-ROM, without further permission from you.</li>
                <li class='small-bottom-padding'>If you have drafts from a permissible source to contribute but are not their author, please <a href='/contact'>contact us</a> instead of uploading them here.</li>
            </ul>
        </div>
    </div>
    <b-modal auto-focus-button='ok' ref='draftUploadedModalRef' title='Draft Uploaded' ok-title='View Draft »' @ok='handleViewDraft' cancel-title='Continue' :no-close-on-backdrop='true' :no-close-on-esc='true'>
        <div class="d-block text-center">
            Your draft, {{ form.title }} has been saved as id: {{ newPatternId }}.  Would you like to view it now?
        </div>
    </b-modal>
</b-container>

</template>

<script>
import loginControl from './LoginControl.vue'
import dataService from '../mixins/dataService.js'
import urlsService from '../mixins/urlsService.js'

export default {
    mixins: [dataService, urlsService],
    components: {
        loginControl: loginControl
    },
    data: function() {
        return {
            form: {
                title: '',
                areaOfOrigin: ''
            },
            draftImageUrl: null,
            newPatternId: 0,
            draft: null,
            filename: '',
            formSubmitAttempted: false
        }
    },
    methods: {
        discardTemporaryDraft() {
            this.$router.go(this.$router.currentRoute) // reload page
        },
        uploadFile(evt) {
            let file = document.getElementById('fileUpload').files[0]
            let boundThis = this
            // if user hits escape key on login dialog, can still get here without login, make them log in instead of uploading by reloading if that happens
            if (boundThis.isAuthenticated) {
                let fileReader = new FileReader()
                fileReader.onload = function(e) {
                    let WIFData = e.target.result
                    boundThis.postPattern(WIFData, boundThis.authUser.UserID, boundThis.authUser.LoginToken).then(resp => {
                        if (resp.status === 200 && resp.data.length > 0) {
                            boundThis.draftImageUrl = boundThis.getTempDraftImageUrl(boundThis.authUser.UserID, 4, boundThis.authUser.LoginToken)
                        }
                    })
                }
                fileReader.readAsText(file)
            }
        },
        saveDraft() {
            this.postSaveUploadedPattern(this.authUser.UserID, this.authUser.LoginToken, this.form.title, this.form.areaOfOrigin)
            .then((resp) => {
                this.newPatternId = resp.data
                this.getPattern(this.newPatternId).then(resp => {
                    this.draft = resp.data
                    this.showSaveDraftSuccessDialog()
                })
            })
        },
        showSaveDraftSuccessDialog() {
            this.$refs.draftUploadedModalRef.show()
        },
        handleViewDraft() {
            let draftDetailUrl = this.buildDraftDetailUrl(this.draft)
            this.$router.push({ path: draftDetailUrl })
        },
        onSubmit(evt) {
            evt.preventDefault()
            this.formSubmitAttempted = true
            if (!this.isValidTitle()) {
                return false
            }
            this.saveDraft()
        },
        isValidTitle: function() {
            return (this.form.title.trimLeft().length > 0)
        }
    },
    computed: {
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        authUser: function() {
            return this.$store.state.authUser
        }
    }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/DraftUpload.vue